import React, { useEffect, useState } from 'react'
import { useFormContext, useFieldArray } from 'react-hook-form'
import { useTranslate, useNotify } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Delete, Add } from '@mui/icons-material'
import Button from '@mui/material/Button'
import { Grid } from '@mui/material'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
// import { removeBannersByIds } from '../../helper'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import { dueDateServices } from 'src/services/reservation/due-date/dueDate.service'

export const DateRangeArray = ({ editMode = true }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const { control } = useFormContext()
  const [openModal, setOpenModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(null)
  const { fields, append, remove, update } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: 'date_range_relation', // unique name for your Field Array
    keyName: '_id',
  })

  useEffect(() => {
    if (confirmDelete) {
      deleteDateRangeByService(currentIndex)
      setOpenModal(false)
      setCurrentIndex(null)
      setConfirmDelete(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])



  const deleteDateRangeByService = async (index) => {
    try {
      const date_range = fields[index]
      if (editMode && date_range && !('new_register' in date_range)) {
        const status = await dueDateServices.deleteDateRange(date_range?.id)
        if (status >= 200 && status <= 204){
          remove(index)
          notify(`ra.notification.delete_success_date_range`, {
            type: 'success',
          })
          return
        }
      }
      notify(`ra.notification.delete_error_date_range`, {
        type: 'error',
      })
    } catch (error) {
      const messaggeKey = error?.response?.data?.detail
      if (messaggeKey) {
        notify(`${messaggeKey}`, {
          type: 'error',
        })
      } else {
        notify(`ra.notification.delete_error_date_range`, {
          type: 'error'
        })
      }
    }
  }

  const updateDateRange = (index, field, value) => {
    const data = {
      ...fields[index],
      [field]: value,
      update_register: true,
    }
    update(index, data)
  }

  const deleteDateRange = (originalIndex, banner, remove) => {
    if (editMode && !('new_register' in banner)) {
      setOpenModal(true)
      setCurrentIndex(originalIndex)
    } else {
      remove(originalIndex)
    }
  }

  return (
    <>
      <ConfirmationDialog
        title={translate('ra.message.delete_date_rate')}
        buttonConfirmText={translate('ra.action.to_confirm')}
        buttonCancel={translate('ra.action.cancel')}
        setOpen={setOpenModal}
        setConfirm={setConfirmDelete}
        open={openModal}
      />
      {React.Children.toArray(
        fields.map((field, index) => (
          <div
            key={field._id}
            style={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 10,
            }}
          >
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.datetime_from')} required>
                <DatePickers
                  source={`date_range_relation.${index}.date_from`}
                  required
                  viewsShow={false}
                  extraOnChange={(e) => {
                    updateDateRange(index, 'date_from', e)
                  }}
                />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.datetime_to')} required>
                <DatePickers
                  source={`date_range_relation.${index}.date_to`}
                  required
                  viewsShow={false}
                  extraOnChange={(e) => {
                    updateDateRange(index, 'date_to', e)
                  }}
                />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.application_date')} required>
                <DatePickers
                  source={`date_range_relation.${index}.date_final`}
                  required
                  viewsShow={false}
                  extraOnChange={(e) => {
                    updateDateRange(index, 'date_final', e)
                  }}
                />
              </EditInputsWrap>
            </Grid>
            <Grid container spacing={3} justifyContent='flex-end' className='addItemSeparator'>
              <Grid item xs={12} sm={12} className='grid' style={{ marginTop: 10 }}>
                <Button
                  onClick={() => deleteDateRange(index, field, remove)}
                  startIcon={<Delete />}
                  color='error'
                >
                  {translate('ra.action.delete')}
                </Button>
              </Grid>
            </Grid>
          </div>
        ))
      )}
      <Button
        startIcon={<Add />}
        onClick={() => {
          append({
            date_from: null,
            date_to: null,
            date_final: null,
            due_date_range_id: null,
            new_register: true,
          })
        }}
      >
        {translate('ra.action.add_specific', {
          name: translate('ra.field.date_ranges'),
        })}
      </Button>
    </>
  )
}
